export default __webpack_public_path__ + "static/ABCMonumentGrotesk-Regular-b259f9744c1886fc74d6a92e04c7b8b7.woff2";